export const SymanticUnitOfMeasure = [
  {
    symanticType: "Acceleration", displayName: [{ en: "Acceleration" }], base: "gForce", UoM: [
      { unit: "metrePerSecondSquared", displayName: [{ en: "metrePerSecondSquared" }], symbol: "m/s²", multiplier: 0 },
      { unit: "centimetrePerSecondSquared", displayName: [{ en: "centimetrePerSecondSquared" }], symbol: "cm/s²", multiplier: 0 },
      { unit: "gForce", displayName: [{ en: "gForce" }], symbol: "g", multiplier: 0 },
    ]
  },
  {
    symanticType: "Angle", displayName: [{ en: "Angle" }], base: "degreeOfArc", UoM: [
      { unit: "radian", displayName: [{ en: "radian" }], symbol: "rad", multiplier: 0 },
      { unit: "degreeOfArc", displayName: [{ en: "degreeOfArc" }], symbol: "°", multiplier: 0 },
      { unit: "minuteOfArc", displayName: [{ en: "minuteOfArc" }], symbol: "'", multiplier: 0 },
      { unit: "secondOfArc", displayName: [{ en: "secondOfArc" }], symbol: "\"", multiplier: 0 },
      { unit: "turn", displayName: [{ en: "turn" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "AngularAcceleration", displayName: [{ en: "AngularAcceleration" }], base: "radianPerSecondSquared", UoM: [
      { unit: "radianPerSecondSquared", displayName: [{ en: "radianPerSecondSquared" }], symbol: "rad/s²", multiplier: 0 },
    ]
  },
  {
    symanticType: "AngularVelocity", displayName: [{ en: "AngularVelocity" }], base: "", UoM: [
      { unit: "radianPerSecond", displayName: [{ en: "radianPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "degreePerSecond", displayName: [{ en: "degreePerSecond" }], symbol: "", multiplier: 0 },
      { unit: "revolutionPerSecond", displayName: [{ en: "revolutionPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "revolutionPerMinute", displayName: [{ en: "revolutionPerMinute" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Area", displayName: [{ en: "Area" }], base: "", UoM: [
      { unit: "squareMetre", displayName: [{ en: "squareMetre" }], symbol: "", multiplier: 0 },
      { unit: "squareCentimetre", displayName: [{ en: "squareCentimetre" }], symbol: "", multiplier: 0 },
      { unit: "squareMillimetre", displayName: [{ en: "squareMillimetre" }], symbol: "", multiplier: 0 },
      { unit: "squareKilometre", displayName: [{ en: "squareKilometre" }], symbol: "", multiplier: 0 },
      { unit: "hectare", displayName: [{ en: "hectare" }], symbol: "", multiplier: 0 },
      { unit: "squareFoot", displayName: [{ en: "squareFoot" }], symbol: "", multiplier: 0 },
      { unit: "squareInch", displayName: [{ en: "squareInch" }], symbol: "", multiplier: 0 },
      { unit: "acre", displayName: [{ en: "acre" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Capacitance", displayName: [{ en: "Capacitance" }], base: "farad", UoM: [
      { unit: "farad", displayName: [{ en: "farad" }], symbol: "F", multiplier: 0 },
      { unit: "millifarad", displayName: [{ en: "millifarad" }], symbol: "mF", multiplier: 0 },
      { unit: "microfarad", displayName: [{ en: "microfarad" }], symbol: "uF", multiplier: 0 },
      { unit: "nanofarad", displayName: [{ en: "nanofarad" }], symbol: "nF", multiplier: 0 },
      { unit: "picofarad", displayName: [{ en: "picofarad" }], symbol: "pF", multiplier: 0 },
    ]
  },
  {
    symanticType: "Current", displayName: [{ en: "Current" }], base: "ampere", UoM: [
      { unit: "ampere", displayName: [{ en: "ampere" }], symbol: "A", multiplier: 0 },
      { unit: "microampere", displayName: [{ en: "microampere" }], symbol: "uA", multiplier: 0 },
      { unit: "milliampere", displayName: [{ en: "milliampere" }], symbol: "mA", multiplier: 0 },
    ]
  },
  {
    symanticType: "DataRate", displayName: [{ en: "DataRate" }], base: "bytePerSecond", UoM: [
      { unit: "bitPerSecond", displayName: [{ en: "bitPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "kibibitPerSecond", displayName: [{ en: "kibibitPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "mebibitPerSecond", displayName: [{ en: "mebibitPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "gibibitPerSecond", displayName: [{ en: "gibibitPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "tebibitPerSecond", displayName: [{ en: "tebibitPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "exbibitPerSecond", displayName: [{ en: "exbibitPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "zebibitPerSecond", displayName: [{ en: "zebibitPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "yobibitPerSecond", displayName: [{ en: "yobibitPerSecond" }], symbol: "", multiplier: 0 },
      { unit: "bytePerSecond", displayName: [{ en: "bytePerSecond" }], symbol: "", multiplier: 0 },
      { unit: "kibibytePerSecond", displayName: [{ en: "kibibytePerSecond" }], symbol: "", multiplier: 0 },
      { unit: "mebibytePerSecond", displayName: [{ en: "mebibytePerSecond" }], symbol: "", multiplier: 0 },
      { unit: "gibibytePerSecond", displayName: [{ en: "gibibytePerSecond" }], symbol: "", multiplier: 0 },
      { unit: "tebibytePerSecond", displayName: [{ en: "tebibytePerSecond" }], symbol: "", multiplier: 0 },
      { unit: "exbibytePerSecond", displayName: [{ en: "exbibytePerSecond" }], symbol: "", multiplier: 0 },
      { unit: "zebibytePerSecond", displayName: [{ en: "zebibytePerSecond" }], symbol: "", multiplier: 0 },
      { unit: "yobibytePerSecond", displayName: [{ en: "yobibytePerSecond" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "DataSize", displayName: [{ en: "DataSize" }], base: "byte", UoM: [
      { unit: "bit", displayName: [{ en: "bit" }], symbol: "", multiplier: 0 },
      { unit: "kibibit", displayName: [{ en: "kibibit" }], symbol: "", multiplier: 0 },
      { unit: "mebibit", displayName: [{ en: "mebibit" }], symbol: "", multiplier: 0 },
      { unit: "gibibit", displayName: [{ en: "gibibit" }], symbol: "", multiplier: 0 },
      { unit: "tebibit", displayName: [{ en: "tebibit" }], symbol: "", multiplier: 0 },
      { unit: "exbibit", displayName: [{ en: "exbibit" }], symbol: "", multiplier: 0 },
      { unit: "zebibit", displayName: [{ en: "zebibit" }], symbol: "", multiplier: 0 },
      { unit: "yobibit", displayName: [{ en: "yobibit" }], symbol: "", multiplier: 0 },
      { unit: "byte", displayName: [{ en: "byte" }], symbol: "", multiplier: 0 },
      { unit: "kibibyte", displayName: [{ en: "kibibyte" }], symbol: "", multiplier: 0 },
      { unit: "mebibyte", displayName: [{ en: "mebibyte" }], symbol: "", multiplier: 0 },
      { unit: "gibibyte", displayName: [{ en: "gibibyte" }], symbol: "", multiplier: 0 },
      { unit: "tebibyte", displayName: [{ en: "tebibyte" }], symbol: "", multiplier: 0 },
      { unit: "exbibyte", displayName: [{ en: "exbibyte" }], symbol: "", multiplier: 0 },
      { unit: "zebibyte", displayName: [{ en: "zebibyte" }], symbol: "", multiplier: 0 },
      { unit: "yobibyte", displayName: [{ en: "yobibyte" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Density", displayName: [{ en: "Density" }], base: "gramPerCubicMetre", UoM: [
      { unit: "kilogramPerCubicMetre", displayName: [{ en: "kilogramPerCubicMetre" }], symbol: "kg/m³", multiplier: 0 },
      { unit: "gramPerCubicMetre", displayName: [{ en: "gramPerCubicMetre" }], symbol: "g/m³", multiplier: 0 },
    ]
  },
  {
    symanticType: "Distance", displayName: [{ en: "Distance" }], base: "metre", UoM: [
      { unit: "metre", displayName: [{ en: "metre" }], symbol: "", multiplier: 0 },
      { unit: "centimetre", displayName: [{ en: "centimetre" }], symbol: "", multiplier: 0 },
      { unit: "millimetre", displayName: [{ en: "millimetre" }], symbol: "", multiplier: 0 },
      { unit: "micrometre", displayName: [{ en: "micrometre" }], symbol: "", multiplier: 0 },
      { unit: "nanometre", displayName: [{ en: "nanometre" }], symbol: "", multiplier: 0 },
      { unit: "kilometre", displayName: [{ en: "kilometre" }], symbol: "", multiplier: 0 },
      { unit: "foot", displayName: [{ en: "foot" }], symbol: "", multiplier: 0 },
      { unit: "inch", displayName: [{ en: "inch" }], symbol: "", multiplier: 0 },
      { unit: "mile", displayName: [{ en: "mile" }], symbol: "", multiplier: 0 },
      { unit: "nauticalMile", displayName: [{ en: "nauticalMile" }], symbol: "", multiplier: 0 },
      { unit: "astronomicalUnit", displayName: [{ en: "astronomicalUnit" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "ElectricCharge", displayName: [{ en: "ElectricCharge" }], base: "", UoM: [
      { unit: "coulomb", displayName: [{ en: "coulomb" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Energy", displayName: [{ en: "Energy" }], base: "kilowattHour", UoM: [
      { unit: "joule", displayName: [{ en: "joule" }], symbol: "J", multiplier: 0 },
      { unit: "kilojoule", displayName: [{ en: "kilojoule" }], symbol: "kJ", multiplier: 0 },
      { unit: "megajoule", displayName: [{ en: "megajoule" }], symbol: "mJ", multiplier: 0 },
      { unit: "gigajoule", displayName: [{ en: "gigajoule" }], symbol: "gJ", multiplier: 0 },
      { unit: "electronvolt", displayName: [{ en: "electronvolt" }], symbol: "eV", multiplier: 0 },
      { unit: "megaelectronvolt", displayName: [{ en: "megaelectronvolt" }], symbol: "", multiplier: 0 },
      { unit: "wattHour", displayName: [{ en: "wattHour" }], symbol: "Wh", multiplier: 0 },
      { unit: "kilowattHour", displayName: [{ en: "kilowattHour" }], symbol: "kWh", multiplier: 0 },
      { unit: "megawattHour", displayName: [{ en: "megawattHour" }], symbol: "mWh", multiplier: 0 },
    ]
  },
  {
    symanticType: "Force", displayName: [{ en: "Force" }], base: "", UoM: [
      { unit: "newton", displayName: [{ en: "newton" }], symbol: "", multiplier: 0 },
      { unit: "pound", displayName: [{ en: "pound" }], symbol: "", multiplier: 0 },
      { unit: "ounce", displayName: [{ en: "ounce" }], symbol: "", multiplier: 0 },
      { unit: "ton", displayName: [{ en: "ton" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Frequency", displayName: [{ en: "Frequency" }], base: "hertz", UoM: [
      { unit: "hertz", displayName: [{ en: "hertz" }], symbol: "Hz", multiplier: 0 },
      { unit: "kilohertz", displayName: [{ en: "kilohertz" }], symbol: "kHz", multiplier: 0 },
      { unit: "megahertz", displayName: [{ en: "megahertz" }], symbol: "mHz", multiplier: 0 },
      { unit: "gigahertz", displayName: [{ en: "gigahertz" }], symbol: "gHz", multiplier: 0 },
    ]
  },
  {
    symanticType: "Humidity", displayName: [{ en: "Humidity" }], base: "gramPerCubicMetre", UoM: [
      { unit: "kilogramPerCubicMetre", displayName: [{ en: "kilogramPerCubicMetre" }], symbol: "kg/m³", multiplier: 0 },
      { unit: "gramPerCubicMetre", displayName: [{ en: "gramPerCubicMetre" }], symbol: "g/m³", multiplier: 0 },
    ]
  },
  {
    symanticType: "Illuminance", displayName: [{ en: "Illuminance" }], base: "lux", UoM: [
      { unit: "lux", displayName: [{ en: "lux" }], symbol: "lx", multiplier: 0 },
      { unit: "footcandle", displayName: [{ en: "footcandle" }], symbol: "fc", multiplier: 0 },
    ]
  },
  {
    symanticType: "Inductance", displayName: [{ en: "Inductance" }], base: "H", UoM: [
      { unit: "henry", displayName: [{ en: "henry" }], symbol: "H", multiplier: 0 },
      { unit: "millihenry", displayName: [{ en: "millihenry" }], symbol: "mH", multiplier: 0 },
      { unit: "microhenry", displayName: [{ en: "microhenry" }], symbol: "uH", multiplier: 0 },
    ]
  },
  {
    symanticType: "Latitude", displayName: [{ en: "Latitude" }], base: "degreeOfArc", UoM: [
      { unit: "radian", displayName: [{ en: "radian" }], symbol: "rad", multiplier: 0 },
      { unit: "degreeOfArc", displayName: [{ en: "degreeOfArc" }], symbol: "°", multiplier: 0 },
      { unit: "minuteOfArc", displayName: [{ en: "minuteOfArc" }], symbol: "'", multiplier: 0 },
      { unit: "secondOfArc", displayName: [{ en: "secondOfArc" }], symbol: "\"", multiplier: 0 },
      { unit: "turn", displayName: [{ en: "turn" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Longitude", displayName: [{ en: "Longitude" }], base: "degreeOfArc", UoM: [
      { unit: "radian", displayName: [{ en: "radian" }], symbol: "rad", multiplier: 0 },
      { unit: "degreeOfArc", displayName: [{ en: "degreeOfArc" }], symbol: "°", multiplier: 0 },
      { unit: "minuteOfArc", displayName: [{ en: "minuteOfArc" }], symbol: "'", multiplier: 0 },
      { unit: "secondOfArc", displayName: [{ en: "secondOfArc" }], symbol: "\"", multiplier: 0 },
      { unit: "turn", displayName: [{ en: "turn" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Length", displayName: [{ en: "Length" }], base: "", UoM: [
      { unit: "metre", displayName: [{ en: "metre" }], symbol: "", multiplier: 0 },
      { unit: "centimetre", displayName: [{ en: "centimetre" }], symbol: "", multiplier: 0 },
      { unit: "millimetre", displayName: [{ en: "millimetre" }], symbol: "", multiplier: 0 },
      { unit: "micrometre", displayName: [{ en: "micrometre" }], symbol: "", multiplier: 0 },
      { unit: "nanometre", displayName: [{ en: "nanometre" }], symbol: "", multiplier: 0 },
      { unit: "kilometre", displayName: [{ en: "kilometre" }], symbol: "", multiplier: 0 },
      { unit: "foot", displayName: [{ en: "foot" }], symbol: "", multiplier: 0 },
      { unit: "inch", displayName: [{ en: "inch" }], symbol: "", multiplier: 0 },
      { unit: "mile", displayName: [{ en: "mile" }], symbol: "", multiplier: 0 },
      { unit: "nauticalMile", displayName: [{ en: "nauticalMile" }], symbol: "", multiplier: 0 },
      { unit: "astronomicalUnit", displayName: [{ en: "astronomicalUnit" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Luminance", displayName: [{ en: "Luminance" }], base: "candelaPerSquareMetre", UoM: [
      { unit: "candelaPerSquareMetre", displayName: [{ en: "candelaPerSquareMetre" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Luminosity", displayName: [{ en: "Luminosity" }], base: "watt", UoM: [
      { unit: "watt", displayName: [{ en: "watt" }], symbol: "W", multiplier: 0 },
      { unit: "microwatt", displayName: [{ en: "microwatt" }], symbol: "uW", multiplier: 0 },
      { unit: "milliwatt", displayName: [{ en: "milliwatt" }], symbol: "mW", multiplier: 0 },
      { unit: "kilowatt", displayName: [{ en: "kilowatt" }], symbol: "kW", multiplier: 0 },
      { unit: "megawatt", displayName: [{ en: "megawatt" }], symbol: "MW", multiplier: 0 },
      { unit: "gigawatt", displayName: [{ en: "gigawatt" }], symbol: "GW", multiplier: 0 },
      { unit: "horsepower", displayName: [{ en: "horsepower" }], symbol: "hp", multiplier: 0 },
      { unit: "kilowattHourPerYear", displayName: [{ en: "kilowattHourPerYear" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "LuminousFlux", displayName: [{ en: "LuminousFlux" }], base: "lumen", UoM: [
      { unit: "lumen", displayName: [{ en: "lumen" }], symbol: "lm", multiplier: 0 },
    ]
  },
  {
    symanticType: "LuminousIntensity", displayName: [{ en: "LuminousIntensity" }], base: "candela", UoM: [
      { unit: "candela", displayName: [{ en: "candela" }], symbol: "cd", multiplier: 0 },
    ]
  },
  {
    symanticType: "MagneticFlux", displayName: [{ en: "MagneticFlux" }], base: "maxwell", UoM: [
      { unit: "weber", displayName: [{ en: "weber" }], symbol: "Wb", multiplier: 0 },
      { unit: "maxwell", displayName: [{ en: "maxwell" }], symbol: "Mx", multiplier: 0 },
    ]
  },
  {
    symanticType: "MagneticInduction", displayName: [{ en: "MagneticInduction" }], base: "tesla", UoM: [
      { unit: "tesla", displayName: [{ en: "tesla" }], symbol: "", multiplier: 0 },
    ]
  },
  {
    symanticType: "Mass", displayName: [{ en: "Mass" }], base: "gram", UoM: [
      { unit: "kilogram", displayName: [{ en: "kilogram" }], symbol: "kg", multiplier: 0 },
      { unit: "gram", displayName: [{ en: "gram" }], symbol: "g", multiplier: 0 },
      { unit: "milligram", displayName: [{ en: "milligram" }], symbol: "mg", multiplier: 0 },
      { unit: "microgram", displayName: [{ en: "microgram" }], symbol: "ug", multiplier: 0 },
      { unit: "tonne", displayName: [{ en: "tonne" }], symbol: "t", multiplier: 0 },
      { unit: "slug", displayName: [{ en: "slug" }], symbol: "slug", multiplier: 0 },
    ]
  },
  {
    symanticType: "MassFlowRate", displayName: [{ en: "MassFlowRate" }], base: "gramPerSecond", UoM: [
      { unit: "gramPerSecond", displayName: [{ en: "gramPerSecond" }], symbol: "g/s", multiplier: 0 },
      { unit: "kilogramPerSecond", displayName: [{ en: "kilogramPerSecond" }], symbol: "kg·m/s", multiplier: 0 },
      { unit: "gramPerHour", displayName: [{ en: "gramPerHour" }], symbol: "g/h", multiplier: 0 },
      { unit: "kilogramPerHour", displayName: [{ en: "kilogramPerHour" }], symbol: "kg/h", multiplier: 0 },
    ]
  },
  {
    symanticType: "Percent", displayName: [{ en: "Percent" }], base: "percent", UoM: [
      { unit: "percent", displayName: [{ en: "percent" }], symbol: "%", multiplier: 0 },
    ]
  },
  {
    symanticType: "Power", displayName: [{ en: "Power" }], base: "watt", UoM: [
      { unit: "watt", displayName: [{ en: "watt" }], symbol: "W", multiplier: 0 },
      { unit: "microwatt", displayName: [{ en: "microwatt" }], symbol: "mW", multiplier: 0 },
      { unit: "milliwatt", displayName: [{ en: "milliwatt" }], symbol: "mW", multiplier: 0 },
      { unit: "kilowatt", displayName: [{ en: "kilowatt" }], symbol: "kW", multiplier: 0 },
      { unit: "megawatt", displayName: [{ en: "megawatt" }], symbol: "MW", multiplier: 0 },
      { unit: "gigawatt", displayName: [{ en: "gigawatt" }], symbol: "GW", multiplier: 0 },
      { unit: "horsepower", displayName: [{ en: "horsepower" }], symbol: "hp", multiplier: 0 }
    ]
  },
  {
    symanticType: "ReactivePower", displayName: [{ en: "Reactive Power" }], base: "kilovar", UoM: [
      { unit: "var", displayName: [{ en: "VAR" }], symbol: "VAR", multiplier: 0 },
      { unit: "kilovar", displayName: [{ en: "kVAR" }], symbol: "kVAR", multiplier: 0 },
      { unit: "megavar", displayName: [{ en: "MVAR" }], symbol: "MVAR", multiplier: 0 },
    ]
  },
  {
    symanticType: "ReactiveEnergy", displayName: [{ en: "Reactive Power" }], base: "kilovar", UoM: [
      { unit: "varHour", displayName: [{ en: "VARh" }], symbol: "VARh", multiplier: 0 },
      { unit: "kilovarHour", displayName: [{ en: "kVARh" }], symbol: "kVARh", multiplier: 0 },
      { unit: "megavarHour", displayName: [{ en: "MVARh" }], symbol: "MVARh", multiplier: 0 },
    ]
  },
  {
    symanticType: "ApparentPower", displayName: [{ en: "Apparent Power" }], base: "KVA", UoM: [
      { unit: "va", displayName: [{ en: "VA" }], symbol: "VA", multiplier: 0 },
      { unit: "kilova", displayName: [{ en: "KVA" }], symbol: "KVA", multiplier: 0 },
      { unit: "megava", displayName: [{ en: "MVA" }], symbol: "MVA", multiplier: 0 },
    ]
  },
  {
    symanticType: "Pressure", displayName: [{ en: "Pressure" }], base: "bar", UoM: [
      { unit: "pascal", displayName: [{ en: "pascal" }], symbol: "Pa", multiplier: 0 },
      { unit: "kilopascal", displayName: [{ en: "kilopascal" }], symbol: "kPa", multiplier: 0 },
      { unit: "bar", displayName: [{ en: "bar" }], symbol: "bar", multiplier: 0 },
      { unit: "millibar", displayName: [{ en: "millibar" }], symbol: "mbar", multiplier: 0 },
      { unit: "millimetresOfMercury", displayName: [{ en: "millimetresOfMercury" }], symbol: "mmHg", multiplier: 0 },
      { unit: "poundPerSquareInch", displayName: [{ en: "poundPerSquareInch" }], symbol: "PSI", multiplier: 0 },
      { unit: "inchesOfMercury", displayName: [{ en: "inchesOfMercury" }], symbol: "Hg", multiplier: 0 },
      { unit: "inchesOfWater", displayName: [{ en: "inchesOfWater" }], symbol: "H20", multiplier: 0 },
    ]
  },
  {
    symanticType: "RelativeHumidity", displayName: [{ en: "RelativeHumidity" }], base: "percent", UoM: [
      { unit: "percent", displayName: [{ en: "percent" }], symbol: "%rh", multiplier: 0 },
    ]
  },
  {
    symanticType: "Resistance", displayName: [{ en: "Resistance" }], base: "ohm", UoM: [
      { unit: "ohm", displayName: [{ en: "ohm" }], symbol: "Ω", multiplier: 0 },
      { unit: "milliohm", displayName: [{ en: "milliohm" }], symbol: "mΩ", multiplier: 0 },
      { unit: "kiloohm", displayName: [{ en: "kiloohm" }], symbol: "kΩ", multiplier: 0 },
      { unit: "megaohm", displayName: [{ en: "megaohm" }], symbol: "MΩ", multiplier: 0 },
    ]
  },
  {
    symanticType: "SoundPressure", displayName: [{ en: "SoundPressure" }], base: "decibel", UoM: [
      { unit: "decibel", displayName: [{ en: "decibel" }], symbol: "dB", multiplier: 0 },
      { unit: "bel", displayName: [{ en: "bel" }], symbol: "bel", multiplier: 0 },
    ]
  },
  {
    symanticType: "Temperature", displayName: [{ en: "Temperature" }], base: "degreeCelsius", UoM: [
      { unit: "kelvin", displayName: [{ en: "kelvin" }], symbol: "K", multiplier: 0 },
      { unit: "degreeCelsius", displayName: [{ en: "degreeCelsius" }], symbol: "°C", multiplier: 0 },
      { unit: "degreeCelcius", displayName: [{ en: "degreeCelcius" }], symbol: "°C", multiplier: 0 },
      { unit: "degreeFahrenheit", displayName: [{ en: "degreeFahrenheit" }], symbol: "°F", multiplier: 0 },
    ]
  },
  {
    symanticType: "Thrust", displayName: [{ en: "Thrust" }], base: "newton", UoM: [
      { unit: "newton", displayName: [{ en: "newton" }], symbol: "N", multiplier: 0 },
      { unit: "pound", displayName: [{ en: "pound" }], symbol: "lb", multiplier: 0 },
      { unit: "ounce", displayName: [{ en: "ounce" }], symbol: "oz", multiplier: 0 },
      { unit: "ton", displayName: [{ en: "ton" }], symbol: "t", multiplier: 0 },
    ]
  },
  {
    symanticType: "TimeSpan", displayName: [{ en: "TimeSpan" }], base: "millisecond", UoM: [
      { unit: "second", displayName: [{ en: "second" }], symbol: "S", multiplier: 0 },
      { unit: "millisecond", displayName: [{ en: "millisecond" }], symbol: "mS", multiplier: 0 },
      { unit: "microsecond", displayName: [{ en: "microsecond" }], symbol: "uS", multiplier: 0 },
      { unit: "nanosecond", displayName: [{ en: "nanosecond" }], symbol: "nS", multiplier: 0 },
      { unit: "minute", displayName: [{ en: "minute" }], symbol: "M", multiplier: 0 },
      { unit: "hour", displayName: [{ en: "hour" }], symbol: "H", multiplier: 0 },
      { unit: "day", displayName: [{ en: "day" }], symbol: "D", multiplier: 0 },
      { unit: "year", displayName: [{ en: "year" }], symbol: "Y", multiplier: 0 },
    ]
  },
  {
    symanticType: "Torque", displayName: [{ en: "Torque" }], base: "newtonMetre", UoM: [
      { unit: "newtonMetre", displayName: [{ en: "newtonMetre" }], symbol: "N⋅m", multiplier: 0 },
    ]
  },
  {
    symanticType: "Velocity", displayName: [{ en: "Velocity" }], base: "metrePerSecond", UoM: [
      { unit: "metrePerSecond", displayName: [{ en: "metrePerSecond" }], symbol: "m/s", multiplier: 0 },
      { unit: "centimetrePerSecond", displayName: [{ en: "centimetrePerSecond" }], symbol: "cm/s", multiplier: 0 },
      { unit: "kilometrePerSecond", displayName: [{ en: "kilometrePerSecond" }], symbol: "km/s", multiplier: 0 },
      { unit: "metrePerHour", displayName: [{ en: "metrePerHour" }], symbol: "m/h", multiplier: 0 },
      { unit: "kilometrePerHour", displayName: [{ en: "kilometrePerHour" }], symbol: "km/h", multiplier: 0 },
      { unit: "milePerHour", displayName: [{ en: "milePerHour" }], symbol: "mph", multiplier: 0 },
      { unit: "milePerSecond", displayName: [{ en: "milePerSecond" }], symbol: "mps", multiplier: 0 },
      { unit: "knot", displayName: [{ en: "knot" }], symbol: "kn", multiplier: 0 },
    ]
  },
  {
    symanticType: "Voltage", displayName: [{ en: "Voltage" }], base: "volt", UoM: [
      { unit: "volt", displayName: [{ en: "volt" }], symbol: "V", multiplier: 0 },
      { unit: "millivolt", displayName: [{ en: "millivolt" }], symbol: "mV", multiplier: 0 },
      { unit: "microvolt", displayName: [{ en: "microvolt" }], symbol: "uV", multiplier: 0 },
      { unit: "kilovolt", displayName: [{ en: "kilovolt" }], symbol: "kV", multiplier: 0 },
      { unit: "megavolt", displayName: [{ en: "megavolt" }], symbol: "MV", multiplier: 0 },
    ]
  },
  {
    symanticType: "Volume", displayName: [{ en: "Volume" }], base: "cubicMetre", UoM: [
      { unit: "cubicMetre", displayName: [{ en: "cubicMetre" }], symbol: "mᶟ", multiplier: 0 },
      { unit: "cubicCentimetre", displayName: [{ en: "cubicCentimetre" }], symbol: "cmᶟ", multiplier: 0 },
      { unit: "litre", displayName: [{ en: "litre" }], symbol: "l", multiplier: 0 },
      { unit: "millilitre", displayName: [{ en: "millilitre" }], symbol: "ml", multiplier: 0 },
      { unit: "cubicFoot", displayName: [{ en: "cubicFoot" }], symbol: "ftᶟ", multiplier: 0 },
      { unit: "cubicInch", displayName: [{ en: "cubicInch" }], symbol: "inᶟ", multiplier: 0 },
      { unit: "fluidOunce", displayName: [{ en: "fluidOunce" }], symbol: "floz", multiplier: 0 },
      { unit: "gallon", displayName: [{ en: "gallon" }], symbol: "g", multiplier: 0 },
    ]
  },
  {
    symanticType: "VolumeFlowRate", displayName: [{ en: "VolumeFlowRate" }], base: "litrePerSecond", UoM: [
      { unit: "litrePerSecond", displayName: [{ en: "litrePerSecond" }], symbol: "l/s", multiplier: 0 },
      { unit: "millilitrePerSecond", displayName: [{ en: "millilitrePerSecond" }], symbol: "ml/s", multiplier: 0 },
      { unit: "litrePerHour", displayName: [{ en: "litrePerHour" }], symbol: "l/h", multiplier: 0 },
      { unit: "millilitrePerHour", displayName: [{ en: "millilitrePerHour" }], symbol: "ml/h", multiplier: 0 },
    ]
  },
]

